export default "__VITE_ASSET__BbRftoDH__"